import type { TravelCurrencyCode } from '@graphql/generated-base';
import { useGeoBasedLocale, CURRENCY_PARAMS } from './useGeoLocale';
import { getLocalStorage } from '@shared/core';
import { useQueryParamHelper } from '@shared/core/queryString';
import { isTravelCurrencyCode, mapCurrencyCodeToTravelCurrencyCode } from '@shared/utils/currency';
import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { TRAVEL_CURRENCY_STORAGE_KEY } from '@shared/components/TravelCurrencySelector/TravelCurrencySelector';

export const useTravelWhiteLabelCurrency = (eventCurrency?: TravelCurrencyCode | null): TravelCurrencyCode => {
  const { currency: localeCurrency } = useGeoBasedLocale();
  const [isAccommodationsPageCurrencyEnabled] = useIsFeatureEnabled('accommodationsPageCurrencyEnabled');
  const { getValueString } = useQueryParamHelper();

  if (isAccommodationsPageCurrencyEnabled && eventCurrency) {
    return eventCurrency;
  }

  // URL param takes highest priority — allows shared links to override stored preference
  const urlCurrency = getValueString(CURRENCY_PARAMS);
  if (urlCurrency && isTravelCurrencyCode(urlCurrency)) {
    return urlCurrency;
  }

  const travelCurrency = getLocalStorage().getItem(TRAVEL_CURRENCY_STORAGE_KEY);
  if (travelCurrency && isTravelCurrencyCode(travelCurrency)) {
    return travelCurrency;
  }

  return mapCurrencyCodeToTravelCurrencyCode(localeCurrency);
};
